import { Link } from "@tanstack/react-router"
import PhoneSaladLogo from "@/assets/phonesalad-logo.svg?react"
import { cn } from "@/lib/utils"

interface LogoProps {
  size?: "sm" | "md" | "lg"
  className?: string
  linkTo?: string
}

export default function Logo({
  size = "md",
  className,
  linkTo = "/"
}: LogoProps) {
  const logoSizeClasses = {
    sm: "h-6 w-auto",
    md: "h-8 w-auto",
    lg: "h-12 w-auto"
  }

  const content = (
    <>
      <PhoneSaladLogo className={cn(logoSizeClasses[size])} aria-label="PhoneSalad" />
    </>
  )

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        className={cn("flex items-center space-x-2 hover:opacity-80 transition-opacity", className)}
      >
        {content}
      </Link>
    )
  }

  return (
    <div className={cn("flex items-center space-x-2", className)}>
      {content}
    </div>
  )
}
